export class Filter {
    get values() {
        return [...this._values];
    }
    constructor(name, _values, op) {
        this.name = name;
        this._values = _values;
        this.op = op;
    }
}
